module.exports = __webpack_public_path__ + "static/health_facility-e78891339c4dd1ece62363334287b149.png";